<template>
  <div>
    <template v-if="!wapShow">
      <headers :menuIndex="6"></headers>
      <div class="inRegard-banner">
        <div class="app-content" style="position: relative;height: 900px">
          <p class="inRegard-banner-title2">预应力品质工程践行者</p>
          <p class="inRegard-banner-title">交达长期聚焦预应力工程检测细分领域的专业化技术沉淀，从事检测服务、装备开发、科学研究和技术咨询业务</p>

          <!--        <img class="img1" src="@/assets/imgs/home/2.png" />-->
        </div>
      </div>

      <div class="inRegard-content">
        <div class="app-content">
          <p class="title1">交达预应力 - 预应力品质工程践行者</p>

          <div class="app-content inRegard-box">
            <div class="li">
              <div class="background"></div>
              <img class="img1" src="@/assets/imgs/home/1-1.png"/>
              <span class="sp1">价值观</span>
              <span class="sp2">利他、专注、科技</span>
            </div>
            <div class="li">
              <div class="background"></div>
              <img class="img1" src="@/assets/imgs/home/1-2.png"/>
              <span class="sp1">使命</span>
              <span class="sp2">提升工程品质，杜绝质量隐患</span>
            </div>
            <div class="li">

              <div class="background"></div>
              <img class="img1" src="@/assets/imgs/home/1-3.png"/>
              <span class="sp1">愿景</span>
              <span class="sp2">全数量检测的引领者</span>
            </div>
          </div>


          <div class="inRegard-box2 app-content">
            <!--          <p class="title2">关于交达</p>-->

            <div class="flex">
              <div class="inRegard-box2-left">
                <div class="left-li flex">
                  <span>四川交达预应力工程检测科技有限公司（简称：四川交达）是一家在预应力工程领域内专业从事检测服务、装备开发、科学研究和技术咨询业务的高新科技企业。</span>
                </div>
                <div class="left-li flex">
                  <span>四川交达致力于通过数字化技术重新定义预应力工程，开启全数量检测新模式，提供全新解决方案，带动工程检测升级换代和数字化转型，促进工程行业高质量发展。</span>
                </div>
                <div class="left-li flex">
                  <span>四川交达凝聚联合“双一流”高校、研究院所、行业龙头企业等顶尖团队与人才，融合产学研融政，坚持开放创新，打造专业生态，成就合作伙伴。公司以长期聚焦预应力工程检测细分领域的“专业化”技术积淀，以数据驱动工程质量管控向“精细化”发展，开启工程质量全数量无人化检测的“特色化”新模式，引领工程质量检测与管控的数字化转型迈向品质提升的“新颖化”发展之路。公司将始终秉持“专精特新”之道，为行业、客户、合作伙伴及员工提供值得信赖的全新解决方案与高质量服务，并共同引领行业持续、健康、高质量发展，创造更多、更大的价值。</span>
                </div>
              </div>
              <div class="inRegard-box2-right"></div>
            </div>

          </div>


        </div>
        <div class="map-box">
          <div class="app-content flex-sp" style="height: 100%;">
            <div class="map-box-text">
              <div class="map-box-li"><span class="flex" style="align-items: baseline; margin-bottom: 14px;">10+<span
                style="font-size: 26px;">年</span></span>
                <p>预应力检测技术研发积累</p></div>
              <div class="map-box-li"><span class="flex" style="align-items: baseline; margin-bottom: 14px;">100+<span
                style="font-size: 26px;">个</span></span>
                <p>基础设施建设项目实践</p></div>
              <div class="map-box-li"><span class="flex" style="align-items: baseline; margin-bottom: 14px;">1000+<span
                style="font-size: 26px;">项</span></span>
                <p>具体工程（桥梁、边坡、隧道等）应用</p></div>
              <div class="map-box-li"><span class="flex" style="align-items: baseline; margin-bottom: 14px;">1,000,000+<span
                style="font-size: 26px;">孔</span></span>
                <p>现场工程结构检测数据积累</p></div>
              <div class="map-box-li"><span class="flex"  style="align-items: baseline; margin-bottom: 14px;">100,000,000+<span
                style="font-size: 26px;">条</span></span>
                <p>工程大数据挖掘分析与验证</p></div>
            </div>
            <img style="object-fit: cover;" src="@/assets/imgs/home/8.png"></div>

        </div>
      </div>
      <footers></footers>

    </template>
    <template v-else>
      <wap-index></wap-index>
    </template>
  </div>
</template>


<script type="text/javascript">

  import headers from "@/components/header1"
  import footers from "@/components/footers"
  import eventBus from "../../assets/js/eventBus";
  import wapIndex from "../inRegard/wapIndex";

  export default {
    name: 'inRegard',
    components: {headers, footers, wapIndex},
    data() {
      return {
        wapShow: false
      }
    },
    mounted() {
      eventBus.$on("wapShow", (data) => {
        this.wapShow = data;
      })
    },
    methods: {}

  }
</script>

<style scoped>
  .map-box {
    height: 820px;
    border-radius: 0px 0px 0px 0px;
    background-image: url("../../assets/imgs/home/9.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .map-box .map-box-text {
    padding-top: 101px;
  }

  .map-box .map-box-text .map-box-li {
    margin-bottom: 32px;
  }

  .map-box img {
    width: 650px;
    height: 500px;
    margin-right: 130px;
    margin-top: 150px;
  }

  .map-box .map-box-text .map-box-li span {
    font-size: 44px;
    font-family: Titillium Web-Bold, Titillium Web;
    font-weight: bold;
    color: #0071EF;
    letter-spacing: 2px;
  }

  .map-box .map-box-text .map-box-li p {
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
  }
  .inRegard-banner {
    height: 560px;
    background-image: url("../../assets/imgs/inRegard/2.png");
    width: 100%;
    overflow: hidden;
    background-size: cover;
    position: relative;
    margin-top: 80px;
  }

  .inRegard-banner .inRegard-banner-title2 {
    font-size: 38px;
    font-weight: bold;
    letter-spacing: 6px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    color: #000000;
    margin-top: 90px;
    animation-name: fadeInUp;
    margin-left: 17px;
    animation-duration: 1s;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
    opacity: 0;
    display: block;
  }

  .inRegard-banner .inRegard-banner-title {
    width: 614px;
    height: 98px;
    margin-left: 17px;
    line-height: 2;
    animation-duration: 1s;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
    animation-name: fadeInUp;
    font-size: 24px;
    letter-spacing: 4px;
    animation-delay: 1s;
    opacity: 0;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgba(92, 93, 95, 1);
    margin-top: 56px;
  }

  .inRegard-banner .img1 {
    width: 644px;
    height: 448px;
    position: absolute;
    right: 0;
    bottom: 160px;
  }

  .inRegard-content {
    padding-top: 64px;
  }

  .inRegard-content .title1 {
    font-size: 28px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    text-align: center;
  }

  .inRegard-box {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
  }

  .inRegard-box .li {
    width: 389px;
    height: 266px;
    position: relative;
    z-index: 1;
    text-align: center;
  }

  .inRegard-box .li .background {
    width: 100%;
    height: 100%;
    border-radius: 4px 4px 4px 4px;
    background-color: #F1F3F9;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .inRegard-box .li .img1 {
    width: 140px;
    height: 140px;
    display: block;
    margin: 10px auto 0;
  }

  .inRegard-box .li .sp1 {
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    margin: 0 auto 0;
    display: block;
    color: #19203B;

  }

  .inRegard-box .li .sp2 {
    margin: 20px auto 0;
    display: block;
    font-size: 24px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
  }

  .inRegard-box .li:hover .background {
    background: linear-gradient(135deg, #34E4AA 0%, #2C68FF 100%);
    animation: gradientBG 3s ease forwards;

  }

  @keyframes gradientBG {
    0% {
      background-position: 0% 0%;
      opacity: 0.6;
    }
    50% {
      background-position: 50% 50%;
      opacity: 0.4;
    }
    100% {
      background-position: 100% 100%;
      opacity: 0.1;
    }
  }


  .inRegard-box2 {
    margin-top: 76px;
    padding-bottom: 30px;
  }

  .inRegard-box2 .title2 {
    font-size: 21px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
  }

  .inRegard-box2 .inRegard-box2-left {
    margin-top: 40px;
  }

  .inRegard-box2 .inRegard-box2-left .left-li {
    margin-bottom: 27px;
  }

  .inRegard-box2 .inRegard-box2-left .left-li span {
    font-size: 16px;
    width: 682px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    line-height: 2;
  }

  .inRegard-box2 .inRegard-box2-right {
    width: 644px;
    height: 448px;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("../../assets/imgs/home/2.png");
    margin-left: 31px;
  }

</style>



// WEBPACK FOOTER //
// src/view/inRegard/index.vue